import OfferStatus from './offer-status.vue'

export default OfferStatus
